import { render, staticRenderFns } from "./Restricted.vue?vue&type=template&id=e9e47518&scoped=true&"
import script from "./Restricted.vue?vue&type=script&lang=js&"
export * from "./Restricted.vue?vue&type=script&lang=js&"
import style0 from "./Restricted.vue?vue&type=style&index=0&id=e9e47518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e47518",
  null
  
)

export default component.exports